@if (order) {
  <ul class="order-items">
    @for (orderItem of order.orderItems; track orderItem) {
      <li [ngClass]="{ 'feature': orderItem?.orderItemType === 'FEATURE' }">
        <div class="order-item">
          @if (
            orderItem.orderItemType === 'RESOURCE' &&
            orderItem.booking?.registrationNumber ===
            currentBooking?.registrationNumber
            ) {
            <span><mat-icon>directions_car</mat-icon>{{ orderItem.booking?.registrationNumber }}
            <strong>{{orderItem.booking?.bookingStatus === 'CANCELLED' ? 'AVBOKAD': '' }}</strong>
          </span>
        }
        @if (
          orderItem.orderItemType === 'RESOURCE' &&
          orderItem.booking?.registrationNumber !==
          currentBooking?.registrationNumber) {
          <a
            (click)="showBooking(orderItem.booking?.bookingId)"
            [ngClass]="{'order': renderType === 'order'}"
            title="Gå till bokningssidan">
            <mat-icon>directions_car</mat-icon>
            <span>{{orderItem.booking?.registrationNumber }}</span>
            <strong>{{orderItem.booking?.bookingStatus === 'CANCELLED' ? 'AVBOKAD': '' }}</strong>
            <mat-icon class="arrow">chevron_right</mat-icon>
          </a>
        }
        @if (orderItem.orderItemType === 'FEATURE') {
          <span>
            <span class="connect-to-car"></span>
            {{ orderItem.feature?.name }} {{ orderItem.feature?.registrationNumber || '' }}
          </span>
        }
        @if (orderItem.orderItemType === 'PREPAIDTICKET') {
          <span>
            {{ orderItem.prepaidTicket?.name || 'okänt namn' }} (abonnemang)
          </span>
        }
        <span [ngClass]="{ 'value-to-end': orderItem.amount !== undefined }">
          {{ orderItem.amount | number : "1.0-0" }} kr
        </span>
      </div>
      @if (orderItem.orderItemType === 'PREPAIDTICKET') {
        <div class="discount-item order">
          <span>Kommentar: {{orderItem.prepaidTicket?.comment || 'Ingen kommentar angiven'}}</span>
        </div>
      }
      @if (orderItem.discount && orderItem.discount > 0) {
        <div class="discount-item" [ngClass]="{'order': renderType === 'order'}">
          <span>Rabatt: {{orderItem.discountComment}}</span>
          <span class="value-to-end">-{{orderItem.discount}} kr</span>
        </div>
      }
    </li>
  }
</ul>
}